import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
import On1 from "../pdf/OM.pdf"
import pdficon from "../images/pdf-icon.jpg";
function NOC() {
    return (
        <>
            <Header />
            <div className="section">
                <section class="content-section title-top" style={{ backgroundImage: `url(${topback})` }}>
                    <div class="pattern-overlay">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-12 title-heading">
                                    <h2>NOC</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="container">
                    <div class="row">
                        <div class="col-2 d-inline float-none align-self-center"><img class="border rounded pdficon" src={pdficon} style={{ width: '128px;' }} alt="" /></div>
                        <div class="col-6">
                            <p className="pdfpara"><a href={On1} target="_blank" rel="noreferrer"><strong>OM No.F. 1 3 2024-PPD dated 10.07.2024</strong></a></p>
                        </div>
                        <div class="col-2 text-center justify-content-center align-self-center">
                            <div class="progress d-flex align-items-lg-center">
                            </div>
                        </div>
                        <div class="col-2 align-self-center"><a href={On1} target="_blank" rel="noreferrer" class="btn btn-back" style={{ width: '150px;', height: '36px;' }}>Download  <i class="icon ion-ios-arrow-thin-down"></i></a></div>
                    </div>
                </div>

            </div>


            <Footer />
        </>
    );
}

export default NOC;